<template>
	<div class="auth d-flex justify-content-center align-items-center">
		<div class="auth__form theme-bg">
			<h3 class="auth__form__heading py-2 pl-4">
				Sign <span class="auth__form__heading--span-highlight">Up</span>
			</h3>
			<form @submit.prevent="registerUser">
				<vs-input
					:color="'#FAF7FD'"
					:style="
						errors.email
							? '--vs-color: 255,71,87;'
							: '--vs-color: 255,255,255;'
					"
					v-model="registryData.email"
					class="auth__input-parent my-45"
					@input="
						debouncedUniquenessValidation(
							'email',
							registryData.email
						)
					"
					required
					type="email"
					label-placeholder="Email"
					icon-after
				>
					<template #icon>
						<i class="fa fa-envelope"></i>
					</template>

					<template v-if="errors.email" #message-danger>
						{{ errors.email }} You should
						<router-link class="light-link" :to="{ name: 'login' }"
							>log in</router-link
						>.
					</template>
				</vs-input>
				<vs-input
					v-model="registryData.password"
					color="#FAF7FD"
					required
					ref="register-password"
					:visible-password="passwordVisible"
					class="auth__input-parent input-password my-45"
					label-placeholder="Password"
					type="password"
					icon-after
				>
					<template #icon>
						<button
							class="plain-btn"
							type="button"
							tabindex="-1"
							@click="passwordVisible = !passwordVisible"
						>
							<transition mode="out-in" name="v-scaled">
								<i
									key="locked"
									v-if="!passwordVisible"
									class="fa fa-lock"
								>
								</i>
								<i key="open" v-else class="fa fa-lock-open">
								</i>
							</transition>
						</button>
					</template>
				</vs-input>
				<vs-input
					v-model="registryData.name"
					required
					ref="register-name"
					color="#FAF7FD"
					class="auth__input-parent my-45"
					label-placeholder="Name"
					icon-after
				>
					<template #icon>
						<i class="fa fa-user"></i>
					</template>
				</vs-input>

				<vs-input
					v-model="registryData.nickname"
					:color="'#FAF7FD'"
					:style="
						errors.nickname
							? '--vs-color: 255,71,87;'
							: '--vs-color: 255,255,255;'
					"
					danger
					required
					@input="
						debouncedUniquenessValidation(
							'nickname',
							registryData.nickname
						)
					"
					class="auth__input-parent my-45"
					label-placeholder="Nickname"
					icon-after
				>
					<template #icon>
						<i>
							@
						</i>
					</template>
					<template v-if="errors.nickname" #message-danger>
						{{ errors.nickname }}
					</template>
				</vs-input>
				<vs-button
					size="large"
					color="#362EB8"
					type="submit"
					class="d-block m-auto w-50"
				>
					Register
				</vs-button>
				<div
					class="auth__form__extra-action mt-3 text-center text-light"
				>
					<span
						>Already have an account?

						<router-link class="light-link" :to="{ name: 'login' }"
							>Sign In</router-link
						>
					</span>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
import { mapActions } from "vuex"
import notifier from "@/components/mixins/notifier"
import uniquenessValidation from "@/components/mixins/uniquenessValidation"
export default {
	mixins: [notifier, uniquenessValidation(500)],
	data: () => ({
		passwordVisible: false,

		registryData: {
			email: "",
			password: "",
			name: "",
			nickname: ""
		}
	}),
	methods: {
		...mapActions("register", ["REGISTER_USER"]),

		async registerUser() {
			const msg = await this.REGISTER_USER(this.registryData)
			this.openNotification("Account Activation", msg)

			this.$router.push({
				name: "activate-account"
			})
		}
	}
}
</script>

<style></style>
